import { EMAIL_REGEX } from '@asgard/utils';
import { FormSelectOption } from 'components/form/FormSelect/FormSelect.types';
import { z } from 'zod';
import { CompaniesFormFields } from './YourOfferSalaryFormContact.types';

const I18N_PREFIX = 'your-offer-salary:your-offer-salary';

export const DEFAULT_TYPE_OPTION: FormSelectOption = {
  label: 'SELECT_ONE',
  value: ''
};

export const CompaniesFormFieldsSchema = z.object({
  name: z.string(),
  email: z.string(),
  description: z.string(),
  company: z.string(),
  contactPhone: z.string().optional(),
  terms: z.boolean().optional(),
  isSubscribeToNewsletter: z.boolean()
});

export const CompaniesFormFieldsValidationSchema =
  CompaniesFormFieldsSchema.partial()
    // Name required
    .refine((schema) => !!schema.name, {
      path: ['name'],
      message: `${I18N_PREFIX}.form-contact.required-name`
    })

    // Email required
    .refine((schema) => !!schema.email, {
      path: ['email'],
      message: `${I18N_PREFIX}.form-contact.required-email`
    })

    // Email format
    .refine((schema) => schema.email?.match(EMAIL_REGEX), {
      path: ['email'],
      message: `${I18N_PREFIX}.form-contact.invalid-email`
    })

    // Description required
    .refine((schema) => !!schema.description, {
      path: ['description'],
      message: `${I18N_PREFIX}.form-contact.required-description`
    })

    // company required
    .refine((schema) => !!schema.company, {
      path: ['company'],
      message: `${I18N_PREFIX}.form-contact.required-company`
    });

export const FORM_FIELDS_DEFAULT_VALUES: Partial<CompaniesFormFields> = {
  name: '',
  email: '',
  description: '',
  company: '',
  contactPhone: '',
  isSubscribeToNewsletter: false
};
